// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IRating {
  /** Общая оценка **/
  overallScore: EOverallScore;
  /** Вежливость **/
  polite?: TRating_Polite;
  /** Цена/качество **/
  priceAndQuality?: TRating_PriceAndQuality;
  /** Расположение **/
  location?: TRating_Location;
  /** Комфорт и техника **/
  comfortAndAppliance?: TRating_ComfortAndAppliance;
  /** Чистота **/
  cleaning?: TRating_Cleaning;
}

export enum EOverallScore {
  /** Одна звезда **/
  'One' = 'one',
  /** Две звезды **/
  'Two' = 'two',
  /** Три звезды **/
  'Three' = 'three',
  /** Четыре звезды **/
  'Four' = 'four',
  /** Пять звезд **/
  'Five' = 'five',
}
export type TRating_Polite = null | EPolite;

export enum EPolite {
  /** Одна звезда **/
  'One' = 'one',
  /** Две звезды **/
  'Two' = 'two',
  /** Три звезды **/
  'Three' = 'three',
  /** Четыре звезды **/
  'Four' = 'four',
  /** Пять звезд **/
  'Five' = 'five',
}
export type TRating_PriceAndQuality = null | EPriceAndQuality;

export enum EPriceAndQuality {
  /** Одна звезда **/
  'One' = 'one',
  /** Две звезды **/
  'Two' = 'two',
  /** Три звезды **/
  'Three' = 'three',
  /** Четыре звезды **/
  'Four' = 'four',
  /** Пять звезд **/
  'Five' = 'five',
}
export type TRating_Location = null | ELocation;

export enum ELocation {
  /** Одна звезда **/
  'One' = 'one',
  /** Две звезды **/
  'Two' = 'two',
  /** Три звезды **/
  'Three' = 'three',
  /** Четыре звезды **/
  'Four' = 'four',
  /** Пять звезд **/
  'Five' = 'five',
}
export type TRating_ComfortAndAppliance = null | EComfortAndAppliance;

export enum EComfortAndAppliance {
  /** Одна звезда **/
  'One' = 'one',
  /** Две звезды **/
  'Two' = 'two',
  /** Три звезды **/
  'Three' = 'three',
  /** Четыре звезды **/
  'Four' = 'four',
  /** Пять звезд **/
  'Five' = 'five',
}
export type TRating_Cleaning = null | ECleaning;

export enum ECleaning {
  /** Одна звезда **/
  'One' = 'one',
  /** Две звезды **/
  'Two' = 'two',
  /** Три звезды **/
  'Three' = 'three',
  /** Четыре звезды **/
  'Four' = 'four',
  /** Пять звезд **/
  'Five' = 'five',
}
